import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DadosProposta } from '../models/dados-proposta.model';
import { PROPOSTA_FINANCIAMENTO_REPOSITORY, PropostaFinanciamentoRepository } from '../repositories/proposta-financiamento.repository';

@Injectable({
  providedIn: 'root'
})
export class BuscarDadosPropostaUseCase {
  constructor(
    @Inject(PROPOSTA_FINANCIAMENTO_REPOSITORY) private readonly repository: PropostaFinanciamentoRepository
  ) {}

  execute(matricula: string): Observable<DadosProposta> {
    return this.repository.buscarDadosProposta(matricula);
  }
}
